// Constants
import { IMAGE_MIN_HEIGHT_GRID, IMAGE_MIN_WIDTH_GRID } from '../../../common/images/imageConstants';

export const FILE_MIN_WIDTH_GRID = IMAGE_MIN_WIDTH_GRID;
export const FILE_MIN_HEIGHT_GRID = IMAGE_MIN_HEIGHT_GRID;

// Below this width, the meta section and media player look broken
export const FILE_ELEMENT_FULL_DISPLAY_MIN_WIDTH = 20;
